import React from "react";
import {SaveWebsiteContentEpic } from '../../actions/website.actions';
import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom'
import CircularProgress from 'material-ui/CircularProgress';
import WebsiteContentField from '../../components/WebsiteContentField';
import RaisedButton from 'material-ui/RaisedButton';
import EditDomainForm from './EditDomainForm';

export class WebsiteContentSettings extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      website: {
        ...this.props.website
      },
      showUploadDialog: false,
      photoProperty: null,
      changesSaved: false
    };
  }

  onFieldChange = (propertyName, value) => {
    let website = {
      ...this.state.website,
      settings:{
        ...this.state.website.settings,
        [propertyName]: value
      }
    };
    this.setState({website});
  }

  onWebsiteFieldChange = (propertyName, value) => {
    let website = {
      ...this.state.website,
      [propertyName]: value
    };
    this.setState({website});
  }


  onCancel() {
    this.setState({showEdit:false});
  }

  createNewDomain() {
    this.setState({showEdit:true});
  }

  onCreateDomain = (propertyName, value) => {
    let domains = {
      ...this.state.website.domains
    };
    let array = Object.keys(domains).map(key => domains[key])
    array.push(value.domainName);

    this.setState({
      ...this.state,
      website: {
        ...this.state.website,
        domains: array
      },
      showEdit: false
    });
  }

  onSave = () => {
    const saveData = {
      settings : {
        ...this.state.website.settings
      },
      domains : this.state.website.domains
    };

    this.props.save(this.props.website._id, saveData);
  }

  render() {
    if (this.props.loading) {
      return  (
      <div style={{textAlign: 'center'}}>
        <CircularProgress/>
      </div>
      );
    }

    const styles = {
      saveTextSaved: {
        color: '#9E9E9E',
        fontSize: 14,
        fontWeight: '600',
        justifyContent: 'flex-start',
        flexGrow: '1',
      },
      primaryButton: {
        borderRadius: '4px',
        minHeight: 46,
        fontSize: 18,
        fontWeight: '600',
        textTransform: 'capitalize',
        margin: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 56,
      }
    }

    return (
      <div>
        { this.state.website
          ? this.state.website.settings
            ? <div>
                <div className={'save-area'} style={{ backgroundColor:'#EFEFEF', borderBottom:'1px solid #D7D7D7' }}>
                  { this.state.changesSaved 
                    ? <div style={styles.saveTextSaved}>Changes have been saved.</div>
                    : <div style={styles.saveTextSaved}></div>
                  }
                  <RaisedButton buttonStyle={styles.primaryButton} labelStyle={styles.primaryButton} overlayStyle={styles.primaryButton} style={{boxShadow:'none'}} onClick={this.onSave.bind(this)} label="Save" primary={true}/>
                </div>
                <div className={'content-area'}>
                  <WebsiteContentField label="Logo" icon="icon-icon-photo" fontSize="15" value={this.state.website.settings.logoImage} onChange={(value)=> this.onFieldChange('logoImage', value)} type="photo" maxwidth="140" maxheight="100" photoSize="500px width, 175px height" photoFormat="JPG" />
                  <WebsiteContentField label="Divider" icon="icon-icon-photo" fontSize="15" value={this.state.website.settings.dividerImage} onChange={(value)=> this.onFieldChange('dividerImage', value)} type="photo" maxwidth="160" maxheight="100" photoSize="224px width, 14px height" photoFormat="Transparent PNG" />
                  <WebsiteContentField label="Website Description" icon="icon-icon-quotes" fontSize="12" value={this.state.website.settings.metaDescription} onChange={(value)=> this.onFieldChange('metaDescription', value)} type="text" />
                  <WebsiteContentField label="Template" icon="icon-icon-quotes" fontSize="12" value={this.state.website.settings.template} onChange={(value)=> this.onFieldChange('template', value)} type="text" />
                  <div style={{ height: 10 }}>&nbsp;</div>
                  <WebsiteContentField label="Domains" icon="icon-icon-gear" fontSize="15" value={this.state.website.domains} onChange={(value)=> this.onWebsiteFieldChange('domains', value)} type="domainlist" />
                  {this.state.showEdit ? <EditDomainForm show={this.state.showEdit} model={this.state.event} onSubmit={(value)=> this.onCreateDomain('domain', value)} onClose={this.onCancel.bind(this)} /> : null}
                </div>
              </div>
            : <span></span>
          : <div>
              Website is not yet configured for your company.
            </div>
        }


      </div>
    );
  }
}

let mapStateToProps = ({websiteEndpoint},{match}) => ({
  loading: websiteEndpoint.fetchInProgress,
  error: websiteEndpoint.fetchError? true:false,
  website: websiteEndpoint.website
})

let mapDispatchToProps = (dispatch) => ({
  save : (id, data) => dispatch(SaveWebsiteContentEpic(id, data))
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(WebsiteContentSettings));



// WEBPACK FOOTER //
// ./src/containers/Website/WebsiteContentSettings.js